'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * A Promise to delay a Promise
 * @param timeout number
 * @returns Promise<void>
 */ const delay = (timeout)=>new Promise((_)=>setTimeout(_, timeout));

exports.delay = delay;
//# sourceMappingURL=delay.js.map
